module.exports = __webpack_public_path__ + "img/4.bf7d8fd4.png";